import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const LoaderButton = ({
  isLoading,
  disabled,
  children,
  className,
  style,
  onClick,
  ...props
}) => {
  return (
    <button
      className={className}
      disabled={disabled || isLoading}
      onClick={onClick}
      style={style}
      {...props}
    >
      {isLoading ? (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          style={{ marginRight: '8px' }}
        />
      ) : null}
      {children}
    </button>
  );
};

LoaderButton.propTypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};

LoaderButton.defaultProps = {
  isLoading: false,
  disabled: false
};

export default LoaderButton; 